<template lang="pug">
.quantity-fixed
  .number x{{amount}}
</template>
<script>
export default {
  name: 'QuantityFixed',
  props: {
    amount: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.quantity-fixed
  display: flex
  flex-direction: row
  align-items: center
  .number
    font-size: 36px
    line-height: 50px
    margin: 0
</style>
